
<template>
    <div v-if=companydb_id>
        <InvoiceablesListComponent :companydb_id="companydb_id" :invoiceable_type="'invoice'"/>
    </div>
</template>

<script>
import InvoiceablesListComponent from '@/modules/facturae/infra/InvoiceablesListComponent.vue'
export default {
    name: 'InvoiceList',
    components: {
    InvoiceablesListComponent
    },
    
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },
    
    data() {
        return {
        }
    },
}
</script>